import { api } from '../../../lib/api'

export const GET_MY_SUBSCRIPTIONS_REQUEST = 'GET_MY_SUBSCRIPTIONS_REQUEST'
export const GET_MY_SUBSCRIPTIONS_SUCCESS = 'GET_MY_SUBSCRIPTIONS_SUCCESS'
export const GET_MY_SUBSCRIPTIONS_FAILED = 'GET_MY_SUBSCRIPTIONS_FAILED'

export const getMySubscriptions = function (onComplete) {
    return function (dispatch) {
        dispatch({
            type: GET_MY_SUBSCRIPTIONS_REQUEST
        })
        api.getMyAccountSubscriptions().then(getMySubscriptionsResponse => {
            dispatch({
                type: GET_MY_SUBSCRIPTIONS_SUCCESS,
                payload: getMySubscriptionsResponse
            })
            if (onComplete) onComplete()
        }).catch(error => {
            dispatch({
                type: GET_MY_SUBSCRIPTIONS_FAILED,
                error
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/subscription/get-my-subscriptions.js